import React, { useState } from 'react'
import classNames from 'classnames'

import { Spinner } from 'components/Spinner'

import { callApi, eventApi } from 'api'

import styles from './DashboardMeeting.module.scss'

const DashboardMeeting = ({
  name,
  avatar,
  users,
  time,
  cost,
  descr,
  sessionType,
  callInfo,
  client,
}) => {
  const [showAllUsrs, setShowAllUsers] = useState(false)
  const [showing, setShowing] = useState(false)
  const [loading, setLoading] = useState(false)
  const isEvent = callInfo?.title ? true : false

  const handleShowAllUsers = () => {
    setShowAllUsers(true)
  }

  const parsedCost = parseInt(callInfo?.entry_fee) || 0

  const handleCancel = async (e) => {
    e.preventDefault()
    if (loading) return

    setLoading(true)

    try {
      if (isEvent) {
        await eventApi.cancelEvent(callInfo.id)
      } else {
        await callApi.cancelCall({ id: callInfo.id })
      }
      window.location.reload()
    } finally {
      setShowing(false)
      setLoading(false)
    }
  }

  return (
    <div className={styles.dashboardMeetingContainer}>
      <div
        className={styles.dashboardMeeting}
        onClick={(e) => {
          e.preventDefault()
          setShowing(true)
        }}
      >
        <div className={styles.dashboardMeetingAvatar}>
          {avatar !== null && (
            <img src={avatar} alt={name} className={styles.dashboardMeetingAvatar_in} />
          )}
        </div>
        <div className={styles.dashboardMeetingInfo}>
          <div className={styles.dashboardMeetingCol}>
            <div className={styles.dashboardMeetingTime}>{time}</div>
            <div
              className={classNames(styles.dashboardMeetingMain, {
                [styles.dashboardMeetingMainRow]: descr,
              })}
            >
              {(descr || client) && (
                <div className={styles.dashboardMeetingUsersItem}>{name}</div>
              )}
              {users && !descr && (
                <div
                  className={classNames(styles.dashboardMeetingUsers, {
                    [styles.dashboardMeetingUsersAll]: showAllUsrs,
                  })}
                >
                  {users.map((item) => {
                    return (
                      <div className={styles.dashboardMeetingUsersItem} key={item}>
                        {item}
                      </div>
                    )
                  })}
                  {users.length > 2 && !showAllUsrs && (
                    <button
                      className={styles.dashboardMeetingUsersTrigger}
                      type="button"
                      onClick={handleShowAllUsers}
                    >
                      {users.length - 2} More
                    </button>
                  )}
                  {parsedCost !== 0 && client && (
                    <div className={styles.dashboardMeetingCost}>
                      {cost} {sessionType}
                    </div>
                  )}
                  {parsedCost === 0 && client && (
                    <div className={styles.dashboardMeetingCost}>{sessionType}</div>
                  )}
                  <div className={styles.dashboardMeetingDescr}>{descr}</div>
                </div>
              )}
              {!descr && !client && (
                <div className={styles.dashboardMeetingCost}>{name}</div>
              )}
              {parsedCost !== 0 && client && (
                <div className={styles.dashboardMeetingCost}>
                  {cost} {sessionType}
                </div>
              )}
              {parsedCost === 0 && client && (
                <div className={styles.dashboardMeetingCost}>{sessionType}</div>
              )}
              <div className={styles.dashboardMeetingDescr}>{descr}</div>
            </div>
            <div className={styles.dashboardMeetingCol}></div>
          </div>
        </div>
      </div>
      {showing && (
        <div className={styles.dashboardMeetingCancel}>
          <div className={styles.dashboardMeetingCancelBG}>
            <></>
          </div>
          <div className={styles.dashboardMeetingCancelButton}>
            <button onClick={handleCancel} className={styles.dashboardCancelButton}>
              {isEvent ? 'Cancel Event' : 'Cancel Meeting'}
            </button>
          </div>
        </div>
      )}
      {showing && loading && <Spinner size="sm" />}
    </div>
  )
}

export default DashboardMeeting
